import { NgClass } from '@angular/common';
import { Component, Input } from '@angular/core';

@Component({
  selector: 'sps-payment-status',
  imports: [
    NgClass
  ],
  templateUrl: './sps-payment-status.component.html',
})
export class SpsPaymentStatusComponent {

  @Input() status: 'LIVE' | 'TEST' | 'CLOSED';

}
